import { render, staticRenderFns } from "./AreaLocationSetup.vue?vue&type=template&id=3b9747aa&scoped=true"
import script from "./AreaLocationSetup.vue?vue&type=script&lang=ts"
export * from "./AreaLocationSetup.vue?vue&type=script&lang=ts"
import style0 from "./AreaLocationSetup.vue?vue&type=style&index=0&id=3b9747aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9747aa",
  null
  
)

export default component.exports